import { render, staticRenderFns } from "./SaveFilter.vue?vue&type=template&id=23e8650d&scoped=true"
import script from "./SaveFilter.vue?vue&type=script&lang=ts"
export * from "./SaveFilter.vue?vue&type=script&lang=ts"
import style0 from "./SaveFilter.vue?vue&type=style&index=0&id=23e8650d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e8650d",
  null
  
)

export default component.exports